import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { Project } from "@src/app/models/project";
import { Role } from "@src/app/models/role";
import { AssigntemplaterolesService } from "./service/assigntemplateroles.service";
import { DatastoreService } from "@src/app/helpers/datastore/datastore.service";

import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

@UntilDestroy({ checkProperties: true })
@Component({
  selector: "app-assigntemplateroles",
  templateUrl: "./assigntemplateroles.component.html",
  styleUrls: ["./assigntemplateroles.component.css"],
})
export class AssigntemplaterolesComponent implements OnInit, OnChanges {
  @Input() project: Project;
  @Input() personId: string;
  @Input() disableAssign: boolean;
  roleList: Role[] = [];
  @Input() update: string;

  roleToAssign: string;

  @Output() roleToAssignEE = new EventEmitter<Role>();

  @Output() rolesEE = new EventEmitter<Role[]>();

  constructor(
    private atrsrv: AssigntemplaterolesService,
    private datastore: DatastoreService
  ) {}

  ngOnInit() {
    this.roleList = [];
    this.roleToAssign = "none";
    if (this.project?.templateId) {
      this.datastore.roles$.pipe(untilDestroyed(this)).subscribe((roles) => {
        this.roleList = roles.filter(
          (r) => r.projectId == this.project.projectId
        );
        this.rolesEE.emit(this.roleList);
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.project) {
      this.project = changes.project.currentValue;

      this.roleList = [];
      this.roleList = this.datastore.roles
        .getValue()
        .filter((r) => r.projectId == this.project.projectId);
      this.rolesEE.emit(this.roleList);
    }
    if (changes.personId) {
      this.personId = changes.personId.currentValue;

      this.roleList = [];
      this.roleList = this.datastore.roles
        .getValue()
        .filter((r) => r.projectId == this.project.projectId);
      this.rolesEE.emit(this.roleList);
    }
    if (changes.update) {
      this.removeSelection(this.personId);
    }
  }

  removeSelection(personId: string) {
    for (let asp of this.roleList) {
      if (asp.assignedperson == personId) {
        asp.assignedperson = undefined;
        //console.log('Remove selection',asp);
        this.roleToAssignEE.emit(asp);
      }
    }
  }
  assignTemplateRole() {
    if (this.roleToAssign != "none") {
      let role = this.roleList.find(
        (role) => role.roleId === this.roleToAssign
      );
      if (role) {
        role.organizationId = this.project.organizationId;
        role.assignedperson = this.personId;
        this.roleToAssignEE.emit(role);
      } else {
        this.roleToAssignEE.emit(null);
      }
    } else {
      this.removeSelection(this.personId);
    }
  }
}
